import { schema } from "normalizr";
import { ChartOfAccountSchema } from "../../chart-of-account/schema";

const ExpenseLinesSchema = new schema.Entity("expenseLines", {
  chartAccount: ChartOfAccountSchema
});

const ExpenseLinesArraySchema = new schema.Array(ExpenseLinesSchema);

export { ExpenseLinesSchema, ExpenseLinesArraySchema };